import LegalPage from "./LegalPage";

const SECTIONS = [
  {
    heading: "Acceptance of Terms",
    body: [
      "These Terms & Conditions govern your use of the Adinvo website and the services we provide. By accessing our website, submitting an enquiry, or engaging our services, you agree to be bound by these terms.",
    ],
  },
  {
    heading: "Our Services",
    body: [
      "Adinvo provides performance marketing, digital marketing, website development, social media management, mobile app development, and branding services. The specific scope, deliverables, and fees for any engagement will be defined in a separate proposal or agreement.",
    ],
  },
  {
    heading: "Appointments & Bookings",
    body: [
      "Appointments booked through our website are requests for a consultation and are subject to confirmation by our team. We reserve the right to reschedule or decline a booking. Please provide accurate contact details so we can confirm your meeting.",
    ],
  },
  {
    heading: "Client Responsibilities",
    body: [
      "Clients agree to provide accurate information, timely feedback, and any assets or access required to deliver the agreed services. Delays in providing these may affect timelines and outcomes.",
    ],
  },
  {
    heading: "Payments",
    body: [
      "Fees, payment schedules, and terms for paid engagements are specified in the applicable proposal or agreement. Unless otherwise stated, invoices are due as per the agreed schedule.",
    ],
  },
  {
    heading: "Intellectual Property",
    body: [
      "Upon full payment, ownership of final approved deliverables transfers to the client, except for third-party assets, tools, and Adinvo's own pre-existing methodologies and templates. Adinvo may showcase completed work in its portfolio unless otherwise agreed in writing.",
    ],
  },
  {
    heading: "Limitation of Liability",
    body: [
      "While we apply our best expertise, marketing outcomes can be influenced by factors beyond our control. Adinvo is not liable for indirect, incidental, or consequential damages arising from the use of our services.",
    ],
  },
  {
    heading: "Governing Law",
    body: [
      "These terms are governed by the laws of India, and any disputes shall be subject to the jurisdiction of the courts of Mumbai, Maharashtra.",
    ],
  },
];

export default function Terms() {
  return (
    <LegalPage
      testid="terms-page"
      title="Terms & Conditions"
      updated="December 2025"
      sections={SECTIONS}
    />
  );
}
